<div *ngIf="object" class="field-container" [class.field-container--errored]="object.hasError">
    <textarea class="field"
              [(ngModel)]="object.value"
              [placeholder]="placeHolder" 
              (focusout)="unfocusHandlerAsync()"></textarea>

    <small *ngIf="object.showHint" class="hint-text">{{ object.hintString }}</small>
    <small *ngIf="object.hasError" class="error-text">{{ object.errorString }}</small>
</div>
